module.exports = __webpack_public_path__ + "../resources/img/ic_check_on_line_primary.4eb996b5.svg";